import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { UretimKaydiEditComponent } from './uretim-kaydi-edit.component';
import { UretimKaydiKartComponent } from './uretim-kaydi-kart.component';

@DinamikBilesen({
  id: 'uretim-kaydi',
  baslik: 'Üretim Kaydı',
  aciklama: 'Üretim kaydı ekle',
  ikon: 'experiment',
  kategori: 'uretim',
})
class UretimKaydi {
  paylas_kutusu = UretimKaydiEditComponent;
  paylasilmis_kart = UretimKaydiKartComponent;
}
